import Box from '../../components/layout/Box';
import BookCard from '../../components/BookCard';

import { formatBook } from '../../helpers/formatBook';

import './styles.css';

const BookView = ({ data, isLoggedIn }) => {
  const formattedBook = formatBook(data);

  return (
    <Box className="flex-column">
      <BookCard
        id={data.id}
        title={formattedBook.fullTitle}
        author={formattedBook.author}
        image={formattedBook.image}
        price={formattedBook.price}
        comment={formattedBook.comment}
        condition={formattedBook.condition}
        isbn={formattedBook.isbn}
        user={data.user}
        updatedAt={formattedBook.updatedAt}
        createdAt={formattedBook.createdAt}
        isLoggedIn={isLoggedIn}
      />
    </Box>
  );
};

export default BookView;
